import React from "react";
import "./SelectAutocomplete.css";

class SelectAutocomplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
    };
    this.autocompleteElem = React.createRef();

    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.outsideClickHandler = this.outsideClickHandler.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.outsideClickHandler);
  }

  handleOnFocus() {
    this.setState({
      isFocused: true,
    });
  }

  outsideClickHandler(e) {
    let target = e.target;
    if (this.autocompleteElem.current.contains(target)) {
      this.setState({
        isFocused: true,
      });
    } else {
      this.setState({
        isFocused: false,
      });
    }
  }

  handleOnClick(name, subcountry, country) {
    this.setState({
      isFocused: false,
    });
    this.props.handleOnClick(name, subcountry, country);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.outsideClickHandler);
  }

  render() {
    return (
      <div ref={this.autocompleteElem} className="select-autocomplete">
        {this.props.label ? <label>{this.props.label}</label> : null}

        <div className="select-autocomplete-input">
          <input
            type="text"
            value={this.props.value}
            onChange={this.props.onChange}
            onFocus={this.handleOnFocus}
            placeholder={this.props.placeholder}
            spellCheck={false}
          />
          {this.props.data &&
          this.state.isFocused &&
          this.props.data.length > 0 ? (
            <ul className="select-autocomplete-options">
              {this.props.data.map((d) => (
                <li
                  key={d._id}
                  onClick={() =>
                    this.handleOnClick(d.name, d.subcountry, d.country)
                  }
                >
                  {d.name}, {d.subcountry}, {d.country}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      </div>
    );
  }
}

export default SelectAutocomplete;
